import { createContext } from 'react'
import { CartProviderTypes } from './types'

export const Context = createContext<CartProviderTypes>({
  cartItems: []
})
